import { render, staticRenderFns } from "./RouterWrapper.vue?vue&type=template&id=1ed12b2a"
import script from "./RouterWrapper.vue?vue&type=script&lang=ts"
export * from "./RouterWrapper.vue?vue&type=script&lang=ts"
import style0 from "./RouterWrapper.vue?vue&type=style&index=0&id=1ed12b2a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports